import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetIndrDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INDR_DETAILS, token);
  return res;
};

export const AddIndr = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_INDR, payload, token);
  return res;
};

export const UpdateIndr = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_INDR + payload.id, payload, token);
  return res;
};

export const DeleteIndr = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_INDR + id, id, token);
  return res;
};
